var lt = Object.defineProperty;
var _t = (e, t, n) => t in e ? lt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var W = (e, t, n) => _t(e, typeof t != "symbol" ? t + "" : t, n);
var re, b, Ye, I, xe, Ke, Ve, ae, V, j, Xe, he, _e, de, Q = {}, ee = [], dt = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, oe = Array.isArray;
function N(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function pe(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function Je(e, t, n) {
  var r, i, o, s = {};
  for (o in t) o == "key" ? r = t[o] : o == "ref" ? i = t[o] : s[o] = t[o];
  if (arguments.length > 2 && (s.children = arguments.length > 3 ? re.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (o in e.defaultProps) s[o] === void 0 && (s[o] = e.defaultProps[o]);
  return X(e, s, r, i, null);
}
function X(e, t, n, r, i) {
  var o = { type: e, props: t, key: n, ref: r, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: i ?? ++Ye, __i: -1, __u: 0 };
  return i == null && b.vnode != null && b.vnode(o), o;
}
function ie(e) {
  return e.children;
}
function J(e, t) {
  this.props = e, this.context = t;
}
function O(e, t) {
  if (t == null) return e.__ ? O(e.__, e.__i + 1) : null;
  for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
  return typeof e.type == "function" ? O(e) : null;
}
function ut(e) {
  if (e.__P && e.__d) {
    var t = e.__v, n = t.__e, r = [], i = [], o = N({}, t);
    o.__v = t.__v + 1, b.vnode && b.vnode(o), ge(e.__P, o, t, e.__n, e.__P.namespaceURI, 32 & t.__u ? [n] : null, r, n ?? O(t), !!(32 & t.__u), i), o.__v = t.__v, o.__.__k[o.__i] = o, et(r, o, i), t.__e = t.__ = null, o.__e != n && Ze(o);
  }
}
function Ze(e) {
  if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
    if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
  }), Ze(e);
}
function we(e) {
  (!e.__d && (e.__d = !0) && I.push(e) && !te.__r++ || xe != b.debounceRendering) && ((xe = b.debounceRendering) || Ke)(te);
}
function te() {
  try {
    for (var e, t = 1; I.length; ) I.length > t && I.sort(Ve), e = I.shift(), t = I.length, ut(e);
  } finally {
    I.length = te.__r = 0;
  }
}
function Ge(e, t, n, r, i, o, s, c, _, l, u) {
  var a, f, d, m, w, k, p, g = r && r.__k || ee, A = t.length;
  for (_ = ft(n, t, g, _, A), a = 0; a < A; a++) (d = n.__k[a]) != null && (f = d.__i != -1 && g[d.__i] || Q, d.__i = a, k = ge(e, d, f, i, o, s, c, _, l, u), m = d.__e, d.ref && f.ref != d.ref && (f.ref && me(f.ref, null, d), u.push(d.ref, d.__c || m, d)), w == null && m != null && (w = m), (p = !!(4 & d.__u)) || f.__k === d.__k ? (_ = Qe(d, _, e, p), p && f.__e && (f.__e = null)) : typeof d.type == "function" && k !== void 0 ? _ = k : m && (_ = m.nextSibling), d.__u &= -7);
  return n.__e = w, _;
}
function ft(e, t, n, r, i) {
  var o, s, c, _, l, u = n.length, a = u, f = 0;
  for (e.__k = new Array(i), o = 0; o < i; o++) (s = t[o]) != null && typeof s != "boolean" && typeof s != "function" ? (typeof s == "string" || typeof s == "number" || typeof s == "bigint" || s.constructor == String ? s = e.__k[o] = X(null, s, null, null, null) : oe(s) ? s = e.__k[o] = X(ie, { children: s }, null, null, null) : s.constructor === void 0 && s.__b > 0 ? s = e.__k[o] = X(s.type, s.props, s.key, s.ref ? s.ref : null, s.__v) : e.__k[o] = s, _ = o + f, s.__ = e, s.__b = e.__b + 1, c = null, (l = s.__i = ht(s, n, _, a)) != -1 && (a--, (c = n[l]) && (c.__u |= 2)), c == null || c.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof s.type != "function" && (s.__u |= 4)) : l != _ && (l == _ - 1 ? f-- : l == _ + 1 ? f++ : (l > _ ? f-- : f++, s.__u |= 4))) : e.__k[o] = null;
  if (a) for (o = 0; o < u; o++) (c = n[o]) != null && !(2 & c.__u) && (c.__e == r && (r = O(c)), nt(c, c));
  return r;
}
function Qe(e, t, n, r) {
  var i, o;
  if (typeof e.type == "function") {
    for (i = e.__k, o = 0; i && o < i.length; o++) i[o] && (i[o].__ = e, t = Qe(i[o], t, n, r));
    return t;
  }
  e.__e != t && (r && (t && e.type && !t.parentNode && (t = O(e)), n.insertBefore(e.__e, t || null)), t = e.__e);
  do
    t = t && t.nextSibling;
  while (t != null && t.nodeType == 8);
  return t;
}
function ht(e, t, n, r) {
  var i, o, s, c = e.key, _ = e.type, l = t[n], u = l != null && (2 & l.__u) == 0;
  if (l === null && c == null || u && c == l.key && _ == l.type) return n;
  if (r > (u ? 1 : 0)) {
    for (i = n - 1, o = n + 1; i >= 0 || o < t.length; ) if ((l = t[s = i >= 0 ? i-- : o++]) != null && !(2 & l.__u) && c == l.key && _ == l.type) return s;
  }
  return -1;
}
function ke(e, t, n) {
  t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || dt.test(t) ? n : n + "px";
}
function q(e, t, n, r, i) {
  var o, s;
  e: if (t == "style") if (typeof n == "string") e.style.cssText = n;
  else {
    if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || ke(e.style, t, "");
    if (n) for (t in n) r && n[t] == r[t] || ke(e.style, t, n[t]);
  }
  else if (t[0] == "o" && t[1] == "n") o = t != (t = t.replace(Xe, "$1")), s = t.toLowerCase(), t = s in e || t == "onFocusOut" || t == "onFocusIn" ? s.slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = n, n ? r ? n[j] = r[j] : (n[j] = he, e.addEventListener(t, o ? de : _e, o)) : e.removeEventListener(t, o ? de : _e, o);
  else {
    if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
      e[t] = n ?? "";
      break e;
    } catch {
    }
    typeof n == "function" || (n == null || n === !1 && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
  }
}
function Se(e) {
  return function(t) {
    if (this.l) {
      var n = this.l[t.type + e];
      if (t[V] == null) t[V] = he++;
      else if (t[V] < n[j]) return;
      return n(b.event ? b.event(t) : t);
    }
  };
}
function ge(e, t, n, r, i, o, s, c, _, l) {
  var u, a, f, d, m, w, k, p, g, A, $, L, B, H, M, E = t.type;
  if (t.constructor !== void 0) return null;
  128 & n.__u && (_ = !!(32 & n.__u), o = [c = t.__e = n.__e]), (u = b.__b) && u(t);
  e: if (typeof E == "function") try {
    if (p = t.props, g = E.prototype && E.prototype.render, A = (u = E.contextType) && r[u.__c], $ = u ? A ? A.props.value : u.__ : r, n.__c ? k = (a = t.__c = n.__c).__ = a.__E : (g ? t.__c = a = new E(p, $) : (t.__c = a = new J(p, $), a.constructor = E, a.render = gt), A && A.sub(a), a.state || (a.state = {}), a.__n = r, f = a.__d = !0, a.__h = [], a._sb = []), g && a.__s == null && (a.__s = a.state), g && E.getDerivedStateFromProps != null && (a.__s == a.state && (a.__s = N({}, a.__s)), N(a.__s, E.getDerivedStateFromProps(p, a.__s))), d = a.props, m = a.state, a.__v = t, f) g && E.getDerivedStateFromProps == null && a.componentWillMount != null && a.componentWillMount(), g && a.componentDidMount != null && a.__h.push(a.componentDidMount);
    else {
      if (g && E.getDerivedStateFromProps == null && p !== d && a.componentWillReceiveProps != null && a.componentWillReceiveProps(p, $), t.__v == n.__v || !a.__e && a.shouldComponentUpdate != null && a.shouldComponentUpdate(p, a.__s, $) === !1) {
        t.__v != n.__v && (a.props = p, a.state = a.__s, a.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.some(function(v) {
          v && (v.__ = t);
        }), ee.push.apply(a.__h, a._sb), a._sb = [], a.__h.length && s.push(a);
        break e;
      }
      a.componentWillUpdate != null && a.componentWillUpdate(p, a.__s, $), g && a.componentDidUpdate != null && a.__h.push(function() {
        a.componentDidUpdate(d, m, w);
      });
    }
    if (a.context = $, a.props = p, a.__P = e, a.__e = !1, L = b.__r, B = 0, g) a.state = a.__s, a.__d = !1, L && L(t), u = a.render(a.props, a.state, a.context), ee.push.apply(a.__h, a._sb), a._sb = [];
    else do
      a.__d = !1, L && L(t), u = a.render(a.props, a.state, a.context), a.state = a.__s;
    while (a.__d && ++B < 25);
    a.state = a.__s, a.getChildContext != null && (r = N(N({}, r), a.getChildContext())), g && !f && a.getSnapshotBeforeUpdate != null && (w = a.getSnapshotBeforeUpdate(d, m)), H = u != null && u.type === ie && u.key == null ? tt(u.props.children) : u, c = Ge(e, oe(H) ? H : [H], t, n, r, i, o, s, c, _, l), a.base = t.__e, t.__u &= -161, a.__h.length && s.push(a), k && (a.__E = a.__ = null);
  } catch (v) {
    if (t.__v = null, _ || o != null) if (v.then) {
      for (t.__u |= _ ? 160 : 128; c && c.nodeType == 8 && c.nextSibling; ) c = c.nextSibling;
      o[o.indexOf(c)] = null, t.__e = c;
    } else {
      for (M = o.length; M--; ) pe(o[M]);
      ue(t);
    }
    else t.__e = n.__e, t.__k = n.__k, v.then || ue(t);
    b.__e(v, t, n);
  }
  else o == null && t.__v == n.__v ? (t.__k = n.__k, t.__e = n.__e) : c = t.__e = pt(n.__e, t, n, r, i, o, s, _, l);
  return (u = b.diffed) && u(t), 128 & t.__u ? void 0 : c;
}
function ue(e) {
  e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(ue));
}
function et(e, t, n) {
  for (var r = 0; r < n.length; r++) me(n[r], n[++r], n[++r]);
  b.__c && b.__c(t, e), e.some(function(i) {
    try {
      e = i.__h, i.__h = [], e.some(function(o) {
        o.call(i);
      });
    } catch (o) {
      b.__e(o, i.__v);
    }
  });
}
function tt(e) {
  return typeof e != "object" || e == null || e.__b > 0 ? e : oe(e) ? e.map(tt) : N({}, e);
}
function pt(e, t, n, r, i, o, s, c, _) {
  var l, u, a, f, d, m, w, k = n.props || Q, p = t.props, g = t.type;
  if (g == "svg" ? i = "http://www.w3.org/2000/svg" : g == "math" ? i = "http://www.w3.org/1998/Math/MathML" : i || (i = "http://www.w3.org/1999/xhtml"), o != null) {
    for (l = 0; l < o.length; l++) if ((d = o[l]) && "setAttribute" in d == !!g && (g ? d.localName == g : d.nodeType == 3)) {
      e = d, o[l] = null;
      break;
    }
  }
  if (e == null) {
    if (g == null) return document.createTextNode(p);
    e = document.createElementNS(i, g, p.is && p), c && (b.__m && b.__m(t, o), c = !1), o = null;
  }
  if (g == null) k === p || c && e.data == p || (e.data = p);
  else {
    if (o = o && re.call(e.childNodes), !c && o != null) for (k = {}, l = 0; l < e.attributes.length; l++) k[(d = e.attributes[l]).name] = d.value;
    for (l in k) d = k[l], l == "dangerouslySetInnerHTML" ? a = d : l == "children" || l in p || l == "value" && "defaultValue" in p || l == "checked" && "defaultChecked" in p || q(e, l, null, d, i);
    for (l in p) d = p[l], l == "children" ? f = d : l == "dangerouslySetInnerHTML" ? u = d : l == "value" ? m = d : l == "checked" ? w = d : c && typeof d != "function" || k[l] === d || q(e, l, d, k[l], i);
    if (u) c || a && (u.__html == a.__html || u.__html == e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
    else if (a && (e.innerHTML = ""), Ge(t.type == "template" ? e.content : e, oe(f) ? f : [f], t, n, r, g == "foreignObject" ? "http://www.w3.org/1999/xhtml" : i, o, s, o ? o[0] : n.__k && O(n, 0), c, _), o != null) for (l = o.length; l--; ) pe(o[l]);
    c || (l = "value", g == "progress" && m == null ? e.removeAttribute("value") : m != null && (m !== e[l] || g == "progress" && !m || g == "option" && m != k[l]) && q(e, l, m, k[l], i), l = "checked", w != null && w != e[l] && q(e, l, w, k[l], i));
  }
  return e;
}
function me(e, t, n) {
  try {
    if (typeof e == "function") {
      var r = typeof e.__u == "function";
      r && e.__u(), r && t == null || (e.__u = e(t));
    } else e.current = t;
  } catch (i) {
    b.__e(i, n);
  }
}
function nt(e, t, n) {
  var r, i;
  if (b.unmount && b.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || me(r, null, t)), (r = e.__c) != null) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (o) {
      b.__e(o, t);
    }
    r.base = r.__P = null;
  }
  if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && nt(r[i], t, n || typeof e.type != "function");
  n || pe(e.__e), e.__c = e.__ = e.__e = void 0;
}
function gt(e, t, n) {
  return this.constructor(e, n);
}
function Te(e, t, n) {
  var r, i, o, s;
  t == document && (t = document.documentElement), b.__ && b.__(e, t), i = (r = !1) ? null : t.__k, o = [], s = [], ge(t, e = t.__k = Je(ie, null, [e]), i || Q, Q, t.namespaceURI, i ? null : t.firstChild ? re.call(t.childNodes) : null, o, i ? i.__e : t.firstChild, r, s), et(o, e, s);
}
re = ee.slice, b = { __e: function(e, t, n, r) {
  for (var i, o, s; t = t.__; ) if ((i = t.__c) && !i.__) try {
    if ((o = i.constructor) && o.getDerivedStateFromError != null && (i.setState(o.getDerivedStateFromError(e)), s = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), s = i.__d), s) return i.__E = i;
  } catch (c) {
    e = c;
  }
  throw e;
} }, Ye = 0, J.prototype.setState = function(e, t) {
  var n;
  n = this.__s != null && this.__s != this.state ? this.__s : this.__s = N({}, this.state), typeof e == "function" && (e = e(N({}, n), this.props)), e && N(n, e), e != null && this.__v && (t && this._sb.push(t), we(this));
}, J.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), we(this));
}, J.prototype.render = ie, I = [], Ke = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Ve = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, te.__r = 0, ae = Math.random().toString(8), V = "__d" + ae, j = "__a" + ae, Xe = /(PointerCapture)$|Capture$/i, he = 0, _e = Se(!1), de = Se(!0);
class R extends Error {
  constructor(n) {
    super(n.message);
    W(this, "code");
    W(this, "http");
    W(this, "details");
    this.name = "CortexApiError", this.code = n.code, this.http = n.http, this.details = n.details;
  }
}
function mt(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = e;
  return typeof t.code == "string" && typeof t.message == "string" && typeof t.http == "number";
}
const Ce = "[DONE]";
function Ee(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; ) {
    const r = e.indexOf(`\r
\r
`, n), i = e.indexOf(`

`, n), o = [r, i].filter((_) => _ >= 0);
    if (o.length === 0)
      break;
    const s = Math.min(...o), c = s === r ? 4 : 2;
    t.push(e.slice(n, s)), n = s + c;
  }
  return { frames: t, rest: e.slice(n) };
}
function Ae(e) {
  const t = e.split(/\r?\n/), n = [];
  for (const r of t)
    r.startsWith("data:") && n.push(r[5] === " " ? r.slice(6) : r.slice(5));
  return n.length === 0 ? null : n.join(`
`);
}
async function* vt(e) {
  const t = e.getReader(), n = new TextDecoder("utf-8");
  let r = "";
  try {
    for (; ; ) {
      const { value: o, done: s } = await t.read();
      if (s)
        break;
      r += n.decode(o, { stream: !0 });
      const { frames: c, rest: _ } = Ee(r);
      r = _;
      for (const l of c) {
        const u = Ae(l);
        if (u !== null) {
          if (u === Ce)
            return;
          try {
            yield JSON.parse(u);
          } catch {
          }
        }
      }
    }
    r += n.decode();
    const { frames: i } = Ee(r + `

`);
    for (const o of i) {
      const s = Ae(o);
      if (!(s === null || s === Ce))
        try {
          yield JSON.parse(s);
        } catch {
        }
    }
  } finally {
    try {
      t.releaseLock();
    } catch {
    }
  }
}
function $e(e, t) {
  return `${e.endsWith("/") ? e.slice(0, -1) : e}${t}`;
}
const bt = /* @__PURE__ */ new Set([429, 502, 503, 504]);
function yt(e) {
  const t = e.headers.get("retry-after");
  if (!t)
    return null;
  const n = Number(t);
  if (Number.isFinite(n) && n >= 0)
    return Math.min(n, 30) * 1e3;
  const r = Date.parse(t);
  return Number.isNaN(r) ? null : Math.max(0, Math.min(3e4, r - Date.now()));
}
function ze(e, t) {
  const n = t * Math.pow(2, e - 1);
  return Math.floor(Math.random() * n);
}
async function Ne(e, t, n, r) {
  const i = Math.max(1, r?.maxAttempts ?? 2), o = r?.baseDelayMs ?? 200;
  for (let s = 1; s <= i; s++)
    try {
      const c = await e(t, n);
      if (c.ok || !bt.has(c.status) || s === i)
        return c;
      const _ = yt(c);
      if (c.status === 429 && _ === null)
        return c;
      await c.body?.cancel().catch(() => {
      });
      const l = _ ?? ze(s, o);
      await Me(l);
    } catch (c) {
      if (n.signal?.aborted || s === i)
        throw c;
      await Me(ze(s, o));
    }
  throw new Error("fetchWithRetry: exhausted attempts");
}
function Me(e) {
  return new Promise((t) => setTimeout(t, e));
}
async function Ie(e) {
  let t = null;
  try {
    t = await e.json();
  } catch {
  }
  throw mt(t) ? new R(t) : new R({
    code: "internal_error",
    message: `request failed with status ${String(e.status)}`,
    http: e.status
  });
}
function xt(e) {
  if (!e.baseUrl)
    throw new Error("createCortexClient: baseUrl is required");
  const t = e.fetch ?? globalThis.fetch?.bind(globalThis);
  if (!t)
    throw new Error("createCortexClient: no fetch available; pass options.fetch");
  const n = e.auth ?? {};
  async function r(s, c = {}) {
    const _ = c.apiKey ?? n.apiKey;
    if (!_)
      throw new Error("mintSession: apiKey is required (pass in createCortexClient or this call)");
    const l = {
      "content-type": "application/json",
      authorization: `Bearer ${_}`
    };
    c.origin && (l.origin = c.origin);
    const u = {
      method: "POST",
      headers: l,
      body: JSON.stringify({ agentId: s })
    }, a = c.signal ?? e.signal;
    a && (u.signal = a);
    const f = await Ne(t, $e(e.baseUrl, "/v1/widget/session"), u, e.retry);
    return f.ok || await Ie(f), await f.json();
  }
  function i(s, c = {}) {
    return {
      [Symbol.asyncIterator]: () => o(s, c)
    };
  }
  async function* o(s, c) {
    const _ = c.sessionToken ?? n.sessionToken, l = c.apiKey ?? n.apiKey;
    if (!_ && !l)
      throw new Error("chat: sessionToken or apiKey is required");
    const u = {
      "content-type": "application/json",
      accept: "text/event-stream"
    };
    _ ? u["x-cortex-session"] = _ : l && (u.authorization = `Bearer ${l}`);
    const a = {
      agentId: s.agentId,
      messages: s.messages
    };
    a.sessionToken = _ ?? "x".repeat(16), s.model !== void 0 && (a.model = s.model), s.provider !== void 0 && (a.provider = s.provider), s.temperature !== void 0 && (a.temperature = s.temperature), s.maxOutputTokens !== void 0 && (a.maxOutputTokens = s.maxOutputTokens), s.requestId !== void 0 && (a.requestId = s.requestId), s.conversationId !== void 0 && (a.conversationId = s.conversationId);
    const f = {
      method: "POST",
      headers: u,
      body: JSON.stringify(a)
    }, d = c.signal ?? e.signal;
    d && (f.signal = d);
    const m = await Ne(t, $e(e.baseUrl, "/v1/chat/stream"), f, e.retry);
    if (m.ok || await Ie(m), !m.body)
      throw new R({
        code: "internal_error",
        message: "empty response body",
        http: m.status
      });
    for await (const w of vt(m.body)) {
      if (w.type === "error" && c.throwOnError)
        throw new R({
          code: w.code,
          message: w.message,
          http: w.http
        });
      yield w;
    }
  }
  return { mintSession: r, chat: i };
}
var wt = 0;
function h(e, t, n, r, i, o) {
  t || (t = {});
  var s, c, _ = t;
  if ("ref" in _) for (c in _ = {}, t) c == "ref" ? s = t[c] : _[c] = t[c];
  var l = { type: e, props: _, key: n, ref: s, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --wt, __i: -1, __u: 0, __source: i, __self: o };
  if (typeof e == "function" && (s = e.defaultProps)) for (c in s) _[c] === void 0 && (_[c] = s[c]);
  return b.vnode && b.vnode(l), l;
}
var F, x, se, Le, U = 0, rt = [], S = b, De = S.__b, He = S.__r, Pe = S.diffed, Oe = S.__c, Re = S.unmount, Be = S.__;
function ve(e, t) {
  S.__h && S.__h(x, e, U || t), U = 0;
  var n = x.__H || (x.__H = { __: [], __h: [] });
  return e >= n.__.length && n.__.push({}), n.__[e];
}
function Y(e) {
  return U = 1, kt(it, e);
}
function kt(e, t, n) {
  var r = ve(F++, 2);
  if (r.t = e, !r.__c && (r.__ = [it(void 0, t), function(c) {
    var _ = r.__N ? r.__N[0] : r.__[0], l = r.t(_, c);
    _ !== l && (r.__N = [l, r.__[1]], r.__c.setState({}));
  }], r.__c = x, !x.__f)) {
    var i = function(c, _, l) {
      if (!r.__c.__H) return !0;
      var u = r.__c.__H.__.filter(function(f) {
        return f.__c;
      });
      if (u.every(function(f) {
        return !f.__N;
      })) return !o || o.call(this, c, _, l);
      var a = r.__c.props !== c;
      return u.some(function(f) {
        if (f.__N) {
          var d = f.__[0];
          f.__ = f.__N, f.__N = void 0, d !== f.__[0] && (a = !0);
        }
      }), o && o.call(this, c, _, l) || a;
    };
    x.__f = !0;
    var o = x.shouldComponentUpdate, s = x.componentWillUpdate;
    x.componentWillUpdate = function(c, _, l) {
      if (this.__e) {
        var u = o;
        o = void 0, i(c, _, l), o = u;
      }
      s && s.call(this, c, _, l);
    }, x.shouldComponentUpdate = i;
  }
  return r.__N || r.__;
}
function ce(e, t) {
  var n = ve(F++, 3);
  !S.__s && ot(n.__H, t) && (n.__ = e, n.u = t, x.__H.__h.push(n));
}
function le(e) {
  return U = 5, ne(function() {
    return { current: e };
  }, []);
}
function ne(e, t) {
  var n = ve(F++, 7);
  return ot(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function je(e, t) {
  return U = 8, ne(function() {
    return e;
  }, t);
}
function St() {
  for (var e; e = rt.shift(); ) {
    var t = e.__H;
    if (e.__P && t) try {
      t.__h.some(Z), t.__h.some(fe), t.__h = [];
    } catch (n) {
      t.__h = [], S.__e(n, e.__v);
    }
  }
}
S.__b = function(e) {
  x = null, De && De(e);
}, S.__ = function(e, t) {
  e && t.__k && t.__k.__m && (e.__m = t.__k.__m), Be && Be(e, t);
}, S.__r = function(e) {
  He && He(e), F = 0;
  var t = (x = e.__c).__H;
  t && (se === x ? (t.__h = [], x.__h = [], t.__.some(function(n) {
    n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
  })) : (t.__h.some(Z), t.__h.some(fe), t.__h = [], F = 0)), se = x;
}, S.diffed = function(e) {
  Pe && Pe(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (rt.push(t) !== 1 && Le === S.requestAnimationFrame || ((Le = S.requestAnimationFrame) || Tt)(St)), t.__H.__.some(function(n) {
    n.u && (n.__H = n.u), n.u = void 0;
  })), se = x = null;
}, S.__c = function(e, t) {
  t.some(function(n) {
    try {
      n.__h.some(Z), n.__h = n.__h.filter(function(r) {
        return !r.__ || fe(r);
      });
    } catch (r) {
      t.some(function(i) {
        i.__h && (i.__h = []);
      }), t = [], S.__e(r, n.__v);
    }
  }), Oe && Oe(e, t);
}, S.unmount = function(e) {
  Re && Re(e);
  var t, n = e.__c;
  n && n.__H && (n.__H.__.some(function(r) {
    try {
      Z(r);
    } catch (i) {
      t = i;
    }
  }), n.__H = void 0, t && S.__e(t, n.__v));
};
var Fe = typeof requestAnimationFrame == "function";
function Tt(e) {
  var t, n = function() {
    clearTimeout(r), Fe && cancelAnimationFrame(t), setTimeout(e);
  }, r = setTimeout(n, 35);
  Fe && (t = requestAnimationFrame(n));
}
function Z(e) {
  var t = x, n = e.__c;
  typeof n == "function" && (e.__c = void 0, n()), x = t;
}
function fe(e) {
  var t = x;
  e.__c = e.__(), x = t;
}
function ot(e, t) {
  return !e || e.length !== t.length || t.some(function(n, r) {
    return n !== e[r];
  });
}
function it(e, t) {
  return typeof t == "function" ? t(e) : t;
}
const Ct = [
  "chat",
  "bubble",
  "message",
  "headset",
  "sparkle"
];
function Et(e) {
  return e !== void 0 && Ct.includes(e);
}
function At() {
  return /* @__PURE__ */ h(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ h("path", { d: "M21 11.5a8.5 8.5 0 0 1-12.4 7.6L3 21l1.9-5.6a8.5 8.5 0 1 1 16.1-3.9z" })
    }
  );
}
function $t() {
  return /* @__PURE__ */ h(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ h("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
    }
  );
}
function zt() {
  return /* @__PURE__ */ h(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ h("path", { d: "M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4l-4 4-4-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" }),
        /* @__PURE__ */ h("circle", { cx: "8", cy: "11", r: "1", fill: "currentColor", stroke: "none" }),
        /* @__PURE__ */ h("circle", { cx: "12", cy: "11", r: "1", fill: "currentColor", stroke: "none" }),
        /* @__PURE__ */ h("circle", { cx: "16", cy: "11", r: "1", fill: "currentColor", stroke: "none" })
      ]
    }
  );
}
function Nt() {
  return /* @__PURE__ */ h(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ h("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
        /* @__PURE__ */ h("path", { d: "M21 19a2 2 0 0 1-2 2h-1v-7h3zM3 19a2 2 0 0 0 2 2h1v-7H3z" })
      ]
    }
  );
}
function Mt() {
  return /* @__PURE__ */ h(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ h("path", { d: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" }),
        /* @__PURE__ */ h("path", { d: "M19 4v3M5 17v3M3 19h3M17 19h3" })
      ]
    }
  );
}
const It = {
  chat: At,
  bubble: $t,
  message: zt,
  headset: Nt,
  sparkle: Mt
}, G = {
  openChat: "Open chat",
  closeChat: "Close chat",
  chatTitle: "Chat",
  messageAria: "Message",
  send: "Send",
  sendAria: "Send message",
  assistantTyping: "Assistant is typing",
  placeholderDefault: "Write a message…",
  draftTooLong: (e, t) => `Message too long (${String(e)} of ${String(t)} characters). Break it into smaller messages.`,
  networkError: "Network error — check your connection and try again.",
  rateLimitedSeconds: (e) => `Too many messages — try again in ${String(e)}s.`,
  errors: {
    invalid_api_key: "Authentication failed. Refresh the page or contact the site owner.",
    invalid_session_token: "Your session expired. Refresh the page to continue.",
    session_expired: "Your session expired. Refresh the page to continue.",
    origin_not_allowed: "This page is not allowed to use this chat. Contact the site owner.",
    plan_limit_exceeded: "Message cap reached for this billing period. Try again later.",
    rate_limited: "Too many messages — try again shortly.",
    account_frozen: "This account is temporarily disabled. Contact support.",
    model_not_in_plan: "This assistant is temporarily unavailable. The site owner needs to update its configuration."
  }
}, Lt = {
  openChat: "Abrir chat",
  closeChat: "Fechar chat",
  chatTitle: "Chat",
  messageAria: "Mensagem",
  send: "Enviar",
  sendAria: "Enviar mensagem",
  assistantTyping: "O assistente está digitando",
  placeholderDefault: "Escreva uma mensagem…",
  draftTooLong: (e, t) => `Mensagem muito longa (${String(e)} de ${String(t)} caracteres). Quebre em mensagens menores.`,
  networkError: "Erro de rede — verifique sua conexão e tente novamente.",
  rateLimitedSeconds: (e) => `Muitas mensagens — tente novamente em ${String(e)}s.`,
  errors: {
    invalid_api_key: "Falha na autenticação. Atualize a página ou entre em contato com o responsável pelo site.",
    invalid_session_token: "Sua sessão expirou. Atualize a página para continuar.",
    session_expired: "Sua sessão expirou. Atualize a página para continuar.",
    origin_not_allowed: "Esta página não está autorizada a usar este chat. Contate o responsável pelo site.",
    plan_limit_exceeded: "Limite de mensagens deste ciclo de cobrança atingido. Tente mais tarde.",
    rate_limited: "Muitas mensagens — tente novamente em instantes.",
    account_frozen: "Esta conta está temporariamente desativada. Contate o suporte.",
    model_not_in_plan: "Este assistente está temporariamente indisponível. O responsável pelo site precisa atualizar a configuração."
  }
}, Dt = {
  openChat: "Abrir chat",
  closeChat: "Cerrar chat",
  chatTitle: "Chat",
  messageAria: "Mensaje",
  send: "Enviar",
  sendAria: "Enviar mensaje",
  assistantTyping: "El asistente está escribiendo",
  placeholderDefault: "Escribe un mensaje…",
  draftTooLong: (e, t) => `Mensaje demasiado largo (${String(e)} de ${String(t)} caracteres). Divídelo en mensajes más cortos.`,
  networkError: "Error de red — comprueba tu conexión e inténtalo de nuevo.",
  rateLimitedSeconds: (e) => `Demasiados mensajes — vuelve a intentarlo en ${String(e)}s.`,
  errors: {
    invalid_api_key: "Error de autenticación. Actualiza la página o contacta con el propietario del sitio.",
    invalid_session_token: "Tu sesión ha expirado. Actualiza la página para continuar.",
    session_expired: "Tu sesión ha expirado. Actualiza la página para continuar.",
    origin_not_allowed: "Esta página no tiene permiso para usar este chat. Contacta con el propietario del sitio.",
    plan_limit_exceeded: "Límite de mensajes alcanzado para este período. Inténtalo más tarde.",
    rate_limited: "Demasiados mensajes — inténtalo de nuevo en breve.",
    account_frozen: "Esta cuenta está temporalmente desactivada. Contacta con soporte.",
    model_not_in_plan: "Este asistente no está disponible temporalmente. El propietario del sitio debe actualizar la configuración."
  }
}, Ht = {
  openChat: "Ouvrir le chat",
  closeChat: "Fermer le chat",
  chatTitle: "Chat",
  messageAria: "Message",
  send: "Envoyer",
  sendAria: "Envoyer le message",
  assistantTyping: "L'assistant est en train d'écrire",
  placeholderDefault: "Écrivez un message…",
  draftTooLong: (e, t) => `Message trop long (${String(e)} sur ${String(t)} caractères). Divisez-le en messages plus courts.`,
  networkError: "Erreur réseau — vérifiez votre connexion et réessayez.",
  rateLimitedSeconds: (e) => `Trop de messages — réessayez dans ${String(e)}s.`,
  errors: {
    invalid_api_key: "Échec de l'authentification. Actualisez la page ou contactez le propriétaire du site.",
    invalid_session_token: "Votre session a expiré. Actualisez la page pour continuer.",
    session_expired: "Votre session a expiré. Actualisez la page pour continuer.",
    origin_not_allowed: "Cette page n'est pas autorisée à utiliser ce chat. Contactez le propriétaire du site.",
    plan_limit_exceeded: "Limite de messages atteinte pour cette période de facturation. Réessayez plus tard.",
    rate_limited: "Trop de messages — réessayez sous peu.",
    account_frozen: "Ce compte est temporairement désactivé. Contactez le support.",
    model_not_in_plan: "Cet assistant est temporairement indisponible. Le propriétaire du site doit mettre à jour sa configuration."
  }
}, Pt = {
  openChat: "Chat öffnen",
  closeChat: "Chat schließen",
  chatTitle: "Chat",
  messageAria: "Nachricht",
  send: "Senden",
  sendAria: "Nachricht senden",
  assistantTyping: "Assistent schreibt",
  placeholderDefault: "Nachricht schreiben…",
  draftTooLong: (e, t) => `Nachricht zu lang (${String(e)} von ${String(t)} Zeichen). Bitte in kürzere Nachrichten aufteilen.`,
  networkError: "Netzwerkfehler — Verbindung prüfen und erneut versuchen.",
  rateLimitedSeconds: (e) => `Zu viele Nachrichten — erneut versuchen in ${String(e)}s.`,
  errors: {
    invalid_api_key: "Authentifizierung fehlgeschlagen. Seite aktualisieren oder Website-Betreiber kontaktieren.",
    invalid_session_token: "Sitzung abgelaufen. Seite aktualisieren, um fortzufahren.",
    session_expired: "Sitzung abgelaufen. Seite aktualisieren, um fortzufahren.",
    origin_not_allowed: "Diese Seite darf diesen Chat nicht verwenden. Website-Betreiber kontaktieren.",
    plan_limit_exceeded: "Nachrichtenlimit für diesen Abrechnungszeitraum erreicht. Bitte später erneut versuchen.",
    rate_limited: "Zu viele Nachrichten — bitte kurz warten.",
    account_frozen: "Dieses Konto ist vorübergehend deaktiviert. Bitte Support kontaktieren.",
    model_not_in_plan: "Dieser Assistent ist vorübergehend nicht verfügbar. Der Website-Betreiber muss die Konfiguration aktualisieren."
  }
}, K = {
  en: G,
  "pt-br": Lt,
  es: Dt,
  fr: Ht,
  de: Pt
}, Ue = {
  pt: "pt-br",
  "pt-pt": "pt-br"
};
function Ot(e) {
  if (!e) return G;
  const t = e.trim().toLowerCase();
  if (t === "") return G;
  const n = K[t];
  if (n) return n;
  const r = Ue[t];
  if (r !== void 0) {
    const o = K[r];
    if (o) return o;
  }
  const i = t.split("-")[0];
  if (i) {
    const o = K[i];
    if (o) return o;
    const s = Ue[i];
    if (s !== void 0) {
      const c = K[s];
      if (c) return c;
    }
  }
  return G;
}
function Rt(e) {
  return (t) => {
    if (t instanceof R) {
      if (t.code === "rate_limited") {
        const n = t.details?.resetMs, r = typeof n == "number" ? n : void 0;
        if (r !== void 0 && r > 0) {
          const i = Math.max(1, Math.ceil(r / 1e3));
          return e.rateLimitedSeconds(i);
        }
      }
      return e.errors[t.code] ?? t.message;
    }
    return t instanceof TypeError ? e.networkError : t instanceof Error ? t.message : "request failed";
  };
}
const P = 32e3, Bt = Math.floor(P * 0.8), We = "cortex:conversationId";
function jt({ config: e, client: t, sessionTokenRef: n, initialOpen: r = !1, inline: i = !1 }) {
  const [o, s] = Y(i || r), [c, _] = Y([]), [l, u] = Y(""), [a, f] = Y(!1), d = ne(() => Ot(e.locale), [e.locale]), m = ne(() => Rt(d), [d]), w = le(null), k = le(null), p = le(
    typeof sessionStorage < "u" ? sessionStorage.getItem(We) : null
  );
  ce(() => {
    o && c.length === 0 && e.greeting && _([{ role: "greeting", content: e.greeting }]);
  }, [o, c.length, e.greeting]), ce(() => {
    const v = w.current;
    v && (v.scrollTop = v.scrollHeight);
  }, [c]), ce(() => {
    o && !a && k.current?.focus();
  }, [o, a]);
  const g = je(async () => {
    const v = l.trim();
    if (!v || a) return;
    if (v.length > P) {
      _((y) => [
        ...y,
        {
          role: "error",
          content: d.draftTooLong(v.length, P)
        }
      ]);
      return;
    }
    u(""), f(!0);
    const st = [...c.filter((y) => y.role === "user" || y.role === "assistant").map((y) => ({ role: y.role, content: y.content })).slice(-59), { role: "user", content: v }];
    _((y) => [
      ...y,
      { role: "user", content: v },
      { role: "assistant", content: "", streaming: !0 }
    ]);
    const ye = {
      agentId: e.agentId,
      messages: st
    };
    p.current && (ye.conversationId = p.current);
    try {
      const y = n ? { sessionToken: n.current } : void 0;
      for await (const z of t.chat(ye, y))
        ct(z);
    } catch (y) {
      y instanceof R && y.code === "invalid_api_key" && console.warn("[cortex-widget] auth rejected — check data-session-token / mint flow");
      const z = m(y);
      _((C) => {
        const T = [...C], D = T[T.length - 1];
        return D?.role === "assistant" && D.streaming && D.content === "" && T.pop(), T.push({ role: "error", content: z }), T;
      });
    } finally {
      f(!1);
    }
    function ct(y) {
      switch (y.type) {
        case "start":
          if (p.current = y.conversationId, typeof sessionStorage < "u")
            try {
              sessionStorage.setItem(We, y.conversationId);
            } catch {
            }
          break;
        case "delta":
          _((z) => {
            const C = [...z], T = C[C.length - 1];
            return T?.role === "assistant" && T.streaming && (C[C.length - 1] = { ...T, content: T.content + y.text }), C;
          });
          break;
        case "done":
          _((z) => {
            const C = [...z], T = C[C.length - 1];
            return T?.role === "assistant" && T.streaming && (C[C.length - 1] = { ...T, streaming: !1 }), C;
          });
          break;
        case "error": {
          const z = d.errors[y.code] ?? y.message;
          _((C) => {
            const T = [...C], D = T[T.length - 1];
            return D?.role === "assistant" && D.streaming && D.content === "" && T.pop(), [...T, { role: "error", content: z }];
          });
          break;
        }
      }
    }
  }, [l, a, c, t, e.agentId, d, m, n]), A = je(
    (v) => {
      v.key === "Enter" && !v.shiftKey && (v.preventDefault(), g());
    },
    [g]
  ), $ = e.position ?? "bottom-right", L = e.launcherIcon ?? "chat", B = e.launcherStyle ?? "filled", H = B === "filled" ? "launcher" : `launcher ${B}`, M = {};
  e.offsetX && (M["--cortex-offset-x"] = e.offsetX), e.offsetY && (M["--cortex-offset-y"] = e.offsetY);
  const E = It[L];
  return !o && !i ? /* @__PURE__ */ h("div", { class: `root ${$}`, style: M, children: /* @__PURE__ */ h(
    "button",
    {
      class: H,
      "aria-label": d.openChat,
      onClick: () => {
        s(!0);
      },
      children: E()
    }
  ) }) : /* @__PURE__ */ h("div", { class: `root ${$}`, style: M, children: /* @__PURE__ */ h("div", { class: "panel", role: "dialog", "aria-label": d.chatTitle, children: [
    /* @__PURE__ */ h("div", { class: "header", children: [
      /* @__PURE__ */ h("span", { children: d.chatTitle }),
      !i && /* @__PURE__ */ h("button", { class: "close", "aria-label": d.closeChat, onClick: () => {
        s(!1);
      }, children: "×" })
    ] }),
    /* @__PURE__ */ h("div", { class: "messages", ref: w, children: c.map((v, be) => /* @__PURE__ */ h("div", { class: `bubble ${v.role === "greeting" ? "assistant" : v.role}`, children: v.content || (v.streaming ? /* @__PURE__ */ h("span", { class: "typing", "aria-label": d.assistantTyping, role: "status", children: [
      /* @__PURE__ */ h("span", {}),
      /* @__PURE__ */ h("span", {}),
      /* @__PURE__ */ h("span", {})
    ] }) : "") }, be)) }),
    l.length > Bt && /* @__PURE__ */ h(
      "div",
      {
        class: `char-count ${l.length > P ? "over" : ""}`,
        role: "status",
        "aria-live": "polite",
        children: [
          l.length,
          "/",
          P
        ]
      }
    ),
    /* @__PURE__ */ h("div", { class: "composer", children: [
      /* @__PURE__ */ h(
        "textarea",
        {
          ref: k,
          class: "input",
          rows: 1,
          placeholder: e.inputPlaceholder ?? d.placeholderDefault,
          value: l,
          onInput: (v) => {
            u(v.currentTarget.value);
          },
          onKeyDown: A,
          disabled: a,
          "aria-label": d.messageAria
        }
      ),
      /* @__PURE__ */ h(
        "button",
        {
          class: "send",
          onClick: () => void g(),
          disabled: a || l.trim() === "" || l.length > P,
          "aria-label": d.sendAria,
          children: d.send
        }
      )
    ] })
  ] }) });
}
const Ft = ["bottom-right", "bottom-left", "top-right", "top-left"];
function Ut(e) {
  return e !== void 0 && Ft.includes(e);
}
const Wt = ["filled", "outline", "soft"];
function qt(e) {
  return e !== void 0 && Wt.includes(e);
}
const Yt = /^(?:0|\d+(?:\.\d+)?(?:px|rem|em|vh|vw|%))$/;
function qe(e) {
  return Yt.test(e.trim());
}
function Kt(e, t) {
  if (!/^https?:\/\//i.test(e) && !(e.startsWith("/") && !e.startsWith("//")))
    throw new Error(
      `${t} must start with http://, https://, or "/" for a same-origin path (got ${JSON.stringify(e)})`
    );
}
const Vt = /^cs_[A-Za-z0-9]{8}_[A-Za-z0-9]{32}$/;
function at(e) {
  if (!Vt.test(e))
    throw new Error(
      `sessionToken must match cs_<prefix8>_<secret32> (got ${String(e.length)} chars starting "${e.slice(0, 3)}")`
    );
}
const Xt = /^(?:#[0-9a-fA-F]{3,8}|[a-zA-Z]{3,32}|(?:rgb|rgba|hsl|hsla)\(\s*-?\d+(?:\.\d+)?%?(?:\s*,\s*-?\d+(?:\.\d+)?%?){2,3}\s*\))$/;
function Jt(e) {
  return Xt.test(e.trim());
}
function Zt(e) {
  const t = (e.apiBase ?? "").trim(), n = (e.agentId ?? "").trim(), r = (e.sessionToken ?? "").trim();
  if (!t) throw new Error("apiBase is required");
  if (Kt(t, "apiBase"), !n) throw new Error("agentId is required");
  if (!r) throw new Error("sessionToken is required");
  at(r);
  const i = {
    apiBase: t,
    agentId: n,
    sessionToken: r,
    position: Ut(e.position) ? e.position : "bottom-right"
  };
  return e.accent && Jt(e.accent) && (i.accent = e.accent), e.greeting && (i.greeting = e.greeting), e.inputPlaceholder && (i.inputPlaceholder = e.inputPlaceholder), Et(e.launcherIcon) && (i.launcherIcon = e.launcherIcon), qt(e.launcherStyle) && (i.launcherStyle = e.launcherStyle), e.offsetX && qe(e.offsetX) && (i.offsetX = e.offsetX.trim()), e.offsetY && qe(e.offsetY) && (i.offsetY = e.offsetY.trim()), e.locale && (i.locale = e.locale.trim()), i;
}
function Gt(e) {
  const t = {}, n = e.dataset.apiBase;
  n && (t.apiBase = n);
  const r = e.dataset.agentId ?? e.dataset.agent;
  r && (t.agentId = r);
  const i = e.dataset.sessionToken;
  return i && (t.sessionToken = i), e.dataset.accent && (t.accent = e.dataset.accent), e.dataset.position && (t.position = e.dataset.position), e.dataset.greeting && (t.greeting = e.dataset.greeting), e.dataset.placeholder && (t.inputPlaceholder = e.dataset.placeholder), e.dataset.launcherIcon && (t.launcherIcon = e.dataset.launcherIcon), e.dataset.launcherStyle && (t.launcherStyle = e.dataset.launcherStyle), e.dataset.offsetX && (t.offsetX = e.dataset.offsetX), e.dataset.offsetY && (t.offsetY = e.dataset.offsetY), e.dataset.locale && (t.locale = e.dataset.locale), t;
}
const Qt = `
  :host {
    --cortex-accent: #6d5aff;
    --cortex-bg: #ffffff;
    --cortex-fg: #1a1a1a;
    --cortex-muted: #6b6b6b;
    --cortex-border: rgba(0, 0, 0, 0.08);
    --cortex-bubble-user: var(--cortex-accent);
    --cortex-bubble-user-fg: #ffffff;
    --cortex-bubble-assistant: #f3f3f7;
    --cortex-bubble-assistant-fg: var(--cortex-fg);
    --cortex-radius: 16px;
    all: initial;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    /* Anchor a top-of-page stacking context on the shadow host itself, not
       just on .root inside the shadow. Without position+z-index here, the
       host <div> is static and any host-page sibling (3rd-party chat button,
       sticky CTA) inside its own stacking context can paint over the panel.
       isolation:isolate is belt-and-braces if a host stylesheet ever
       neutralizes z-index. The :host([data-inline]) override below resets
       this for the dashboard-playground embed case. */
    position: relative;
    z-index: 2147483000;
    isolation: isolate;
  }
  :host([data-inline]) {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .root {
    position: fixed;
    z-index: 2147483000;
    color: var(--cortex-fg);
  }
  /* Corner anchors. Both axes use CSS variables with a 16px fallback so
     the default render stays pixel-identical to before. data-offset-x /
     data-offset-y override the defaults via inline style="--cortex-offset-*"
     set by app.tsx on the .root element. */
  .root.bottom-right { bottom: var(--cortex-offset-y, 16px); right: var(--cortex-offset-x, 16px); }
  .root.bottom-left  { bottom: var(--cortex-offset-y, 16px); left:  var(--cortex-offset-x, 16px); }
  .root.top-right    { top:    var(--cortex-offset-y, 16px); right: var(--cortex-offset-x, 16px); }
  .root.top-left     { top:    var(--cortex-offset-y, 16px); left:  var(--cortex-offset-x, 16px); }

  .launcher {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: none;
    background: var(--cortex-accent);
    color: #fff;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    transition: transform 120ms ease;
  }
  /* Launcher fill modifiers. Specificity is .launcher.outline (two classes)
     > .launcher (one), so these reliably override the base block above
     regardless of source order. The base block stays the filled default. */
  .launcher.outline {
    background: transparent;
    color: var(--cortex-accent);
    border: 2px solid var(--cortex-accent);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  }
  .launcher.soft {
    /* color-mix gives an accent-tinted soft fill at any accent value
       without forcing the caller to pick a second color. Browsers without
       color-mix support (Safari <16.4) fall back to the prior background
       declaration via @supports below. */
    background: color-mix(in srgb, var(--cortex-accent) 12%, transparent);
    color: var(--cortex-accent);
    border: none;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);
  }
  @supports not (background: color-mix(in srgb, red, blue)) {
    .launcher.soft { background: rgba(127, 127, 127, 0.12); }
  }
  .launcher:hover { transform: translateY(-1px); }
  .launcher:focus-visible { outline: 2px solid var(--cortex-accent); outline-offset: 3px; }

  .panel {
    width: 360px;
    max-width: calc(100vw - 32px);
    height: 520px;
    max-height: calc(100vh - 64px);
    background: var(--cortex-bg);
    border-radius: var(--cortex-radius);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid var(--cortex-border);
  }
  .header {
    padding: 12px 16px;
    background: var(--cortex-accent);
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .close {
    background: transparent;
    border: none;
    color: inherit;
    font-size: 20px;
    cursor: pointer;
    padding: 0 4px;
    line-height: 1;
  }
  .messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: var(--cortex-bg);
  }
  .bubble {
    max-width: 85%;
    padding: 10px 14px;
    border-radius: 14px;
    font-size: 14px;
    line-height: 1.4;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .bubble.user {
    align-self: flex-end;
    background: var(--cortex-bubble-user);
    color: var(--cortex-bubble-user-fg);
    border-bottom-right-radius: 4px;
  }
  .bubble.assistant {
    align-self: flex-start;
    background: var(--cortex-bubble-assistant);
    color: var(--cortex-bubble-assistant-fg);
    border-bottom-left-radius: 4px;
  }
  .bubble.error {
    align-self: center;
    background: #ffe8e8;
    color: #b3261e;
    font-size: 12px;
  }
  .typing {
    display: inline-flex;
    gap: 3px;
    padding: 4px 6px;
    align-items: center;
  }
  .typing > span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--cortex-muted);
    animation: cortex-typing 1.2s infinite ease-in-out;
  }
  .typing > span:nth-child(2) { animation-delay: 0.15s; }
  .typing > span:nth-child(3) { animation-delay: 0.3s; }
  @keyframes cortex-typing {
    0%, 80%, 100% { opacity: 0.2; transform: translateY(0); }
    40%           { opacity: 1;   transform: translateY(-2px); }
  }
  @media (prefers-reduced-motion: reduce) {
    .typing > span { animation: none; opacity: 0.6; }
  }
  .char-count {
    padding: 4px 12px 0;
    font-size: 11px;
    color: var(--cortex-muted);
    background: var(--cortex-bg);
    text-align: right;
  }
  .char-count.over {
    color: #b3261e;
    font-weight: 600;
  }
  .composer {
    border-top: 1px solid var(--cortex-border);
    padding: 10px 12px;
    display: flex;
    gap: 8px;
    background: var(--cortex-bg);
  }
  .input {
    flex: 1;
    border: 1px solid var(--cortex-border);
    border-radius: 10px;
    padding: 8px 12px;
    font: inherit;
    font-size: 14px;
    color: var(--cortex-fg);
    background: #fafafb;
    outline: none;
    resize: none;
  }
  .input:focus { border-color: var(--cortex-accent); }
  .send {
    border: none;
    background: var(--cortex-accent);
    color: #fff;
    border-radius: 10px;
    padding: 0 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .send:disabled { opacity: 0.5; cursor: not-allowed; }
`, en = `
  .root {
    position: absolute;
    inset: 0;
  }
  .root.bottom-right, .root.bottom-left, .root.top-right, .root.top-left {
    top: 0; right: 0; bottom: 0; left: 0;
  }
  .panel {
    width: 100%;
    height: 100%;
    max-width: none;
    max-height: none;
    border-radius: 0;
    box-shadow: none;
    border: none;
  }
`;
function tn(e, t, n = !1) {
  const r = e.createElement("style");
  let i = Qt;
  return n && (i += `
${en}`), t && (i += `
:host { --cortex-accent: ${t}; }`), r.textContent = i, r;
}
function nn(e) {
  const t = Zt(e), n = e.container?.ownerDocument ?? globalThis.document;
  if (!n) throw new Error("initCortexWidget: no document available");
  const r = e.container !== void 0, i = e.container ?? n.createElement("div");
  if (i.setAttribute("data-cortex-widget", ""), r && i.setAttribute("data-inline", ""), !e.container) {
    const l = n.querySelectorAll("div[data-cortex-widget]:not([data-inline])");
    for (const u of l)
      u.remove();
    n.body.appendChild(i);
  }
  const o = i.shadowRoot ?? i.attachShadow({ mode: "open" });
  for (; o.firstChild; ) o.removeChild(o.firstChild);
  o.appendChild(tn(n, t.accent, r));
  const s = n.createElement("div");
  o.appendChild(s);
  const c = e.client ?? xt({
    baseUrl: t.apiBase,
    auth: { sessionToken: t.sessionToken }
  }), _ = { current: t.sessionToken };
  return Te(Je(jt, { config: t, client: c, sessionTokenRef: _, inline: r }), s), {
    config: t,
    setSessionToken: (l) => {
      try {
        at(l);
      } catch (u) {
        console.warn("[cortex-widget] setSessionToken: invalid format, keeping previous token", u);
        return;
      }
      _.current = l;
    },
    destroy: () => {
      Te(null, s), e.container || i.remove();
    }
  };
}
function rn() {
  const e = globalThis.document;
  if (!e) return null;
  const t = e.currentScript;
  if (t instanceof HTMLScriptElement) return t;
  const n = e.querySelector("script[data-cortex-widget]");
  return n instanceof HTMLScriptElement ? n : null;
}
function on() {
  const e = rn();
  if (!e || e.dataset.manual === "true") return null;
  const t = Gt(e);
  if (!t.apiBase || !t.agentId || !t.sessionToken)
    return console.warn("[cortex-widget] missing required data-* attributes; skipping auto-init"), null;
  try {
    return nn(t);
  } catch (n) {
    return console.warn("[cortex-widget] auto-init failed:", n), null;
  }
}
on();
export {
  on as autoInit,
  nn as initCortexWidget
};
//# sourceMappingURL=index.js.map
